import { axiosWithJWT } from '@/api/axiosWithJWT';

export const getPostStatus = async (_) => {
  const { data } = await axiosWithJWT.get('/api/PostStatus/GetList');
  return data;
};
